document.addEventListener('DOMContentLoaded', () => {

  // --- 1. LÓGICA DE FILTRADO POR CATEGORÍAS (NIVELES DEPENDIENTES) ---
  const l1Buttons = document.querySelectorAll('[data-filter-l1]');
  const l2Buttons = document.querySelectorAll('[data-filter-l2]');
  const lookCards = document.querySelectorAll('.look-card');

  function filterLooks() {
    const activeL1Btn = document.querySelector('[data-filter-l1].active');
    const activeL2Btn = document.querySelector('[data-filter-l2].active');
    
    if (!activeL1Btn || !activeL2Btn) return; 

    const activeL1 = activeL1Btn.getAttribute('data-filter-l1');
    const activeL2 = activeL2Btn.getAttribute('data-filter-l2');

    // Usamos un Set para guardar qué subcategorías existen en las tarjetas visibles
    const availableL2s = new Set();

    lookCards.forEach(card => {
      const cardL1 = card.getAttribute('data-l1');
      const cardL2 = card.getAttribute('data-l2');

      const matchesL1 = (activeL1 === 'all' || activeL1 === cardL1);
      const matchesL2 = (activeL2 === 'all' || activeL2 === cardL2);

      // Si la tarjeta pasa el primer filtro, registramos su subcategoría como "disponible"
      if (matchesL1) {
        availableL2s.add(cardL2);
      }

      // Aplicar clases para mostrar/ocultar la tarjeta del look
      if (matchesL1 && matchesL2) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
        // Si ocultamos el look, cerramos sus productos también
        const openProducts = card.querySelector('.look-detail-products.show-products');
        if (openProducts) openProducts.classList.remove('show-products');
      }
    });

    // Actualizar la visibilidad de las burbujas de la Fila 2
    l2Buttons.forEach(btn => {
      const btnL2Val = btn.getAttribute('data-filter-l2');
      if (btnL2Val === 'all') {
        btn.style.display = 'inline-block'; // "Ver todo" siempre se ve
      } else if (availableL2s.has(btnL2Val)) {
        btn.style.display = 'inline-block'; // Si está disponible en las tarjetas actuales, la mostramos
      } else {
        btn.style.display = 'none'; // Si no, la escondemos
      }
    });
  }

  // Evento Fila 1 (Nivel Principal)
  l1Buttons.forEach(btn => {
    btn.addEventListener('click', function() {
      l1Buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      // Al cambiar la categoría principal, forzamos la Fila 2 a "Ver todo"
      // para evitar que el usuario se quede atrapado en un filtro vacío
      l2Buttons.forEach(b => b.classList.remove('active'));
      const allL2Btn = document.querySelector('[data-filter-l2="all"]');
      if (allL2Btn) allL2Btn.classList.add('active');

      filterLooks();
    });
  });

  // Evento Fila 2 (Subcategorías)
  l2Buttons.forEach(btn => {
    btn.addEventListener('click', function() {
      l2Buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      filterLooks();
    });
  });

  // Iniciar el filtro al cargar la página por primera vez
  if (l1Buttons.length > 0) {
    filterLooks();
  }


  // --- 2. LÓGICA PARA DESPLEGAR PRODUCTOS ---
  const toggleButtons = document.querySelectorAll('.look-products-toggle');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault(); 
      const parentUnit = this.closest('.look-card');
      const productsContainer = parentUnit.querySelector('.look-detail-products');
      const isOpening = !productsContainer.classList.contains('show-products');
      
      if (productsContainer) {
        if (isOpening) {
          // ABRIR EL CONTENEDOR
          productsContainer.classList.add('show-products');
          this.classList.add('is-open'); 
          
          // Scroll automático hacia los productos (todas las pantallas)
          setTimeout(() => {
            const rect = productsContainer.getBoundingClientRect();
            // Offset para que el menú fijo no tape la parte superior
            const headerOffset = 120; 
            const targetPosition = rect.top + window.scrollY - headerOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }, 450); // Tiempo para que termine la animación del acordeón
          
        } else {
          // CERRAR EL CONTENEDOR
          productsContainer.classList.remove('show-products');
          this.classList.remove('is-open'); 
          
          // Scroll de retorno hacia la imagen del look (todas las pantallas)
          setTimeout(() => {
            const cardRect = parentUnit.getBoundingClientRect();
            const headerOffset = 120; 
            const targetPosition = cardRect.top + window.scrollY - headerOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }, 100); // Pequeño delay para no pisar el inicio de la animación de cierre
        }
      }
    });
  });


  // --- 3. LÓGICA DEL CARRITO AJAX MÚLTIPLE ---
  
  const updateLookSubmitBtn = (lookContainer) => {
    const submitBtn = lookContainer.querySelector('.js-global-submit');
    if (!submitBtn) return;
    
    const btnText = submitBtn.querySelector('.stl-btn-text');
    let selectedCount = 0;
    
    lookContainer.querySelectorAll('.js-size-select').forEach(select => {
      if(select.value !== "") selectedCount++;
    });

    if(selectedCount > 0) {
      submitBtn.disabled = false;
      btnText.innerText = `AÑADIR AL CARRITO (${selectedCount})`;
    } else {
      submitBtn.disabled = true;
      btnText.innerText = `SELECCIONA TALLAS`;
    }
  };

  // Selector de tallas individual
  document.querySelectorAll('.js-size-select').forEach(select => {
    select.addEventListener('change', function() {
      const itemWrap = this.closest('.stl-item-selector-wrap');
      const clearBtn = itemWrap.querySelector('.js-clear-size');
      if (this.value !== "") clearBtn.style.display = 'block';
      // Actualizar botón del look padre
      updateLookSubmitBtn(this.closest('.look-detail-products'));
    });
  });

  // Limpiar talla
  document.querySelectorAll('.js-clear-size').forEach(btn => {
    btn.addEventListener('click', function() {
      const itemWrap = this.closest('.stl-item-selector-wrap');
      const select = itemWrap.querySelector('.js-size-select');
      select.value = ""; 
      this.style.display = 'none';
      // Actualizar botón del look padre
      updateLookSubmitBtn(this.closest('.look-detail-products'));
    });
  });

  // Enviar a carrito AJAX Global (Por Look)
  document.querySelectorAll('.js-global-submit').forEach(submitBtn => {
    submitBtn.addEventListener('click', async function() {
      const lookContainer = this.closest('.look-detail-products');
      const btnText = this.querySelector('.stl-btn-text');

      const itemsToAdd = [];
      lookContainer.querySelectorAll('.js-size-select').forEach(select => {
        if(select.value !== "") {
          itemsToAdd.push({ id: parseInt(select.value), quantity: 1 });
        }
      });

      if(itemsToAdd.length === 0) return;

      this.classList.add('loading');
      btnText.innerText = 'AÑADIENDO...';

      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      try {
        // Buscamos dinámicamente secciones nativas de Dawn
        let sectionsToRender = ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product', 'cart-notification-button'];
        const cartDrawer = document.querySelector('cart-drawer');
        
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const dynamicSections = cartDrawer.getSectionsToRender().map(s => s.section || s.id);
          if(dynamicSections.length > 0) sectionsToRender = dynamicSections;
        }

        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ 
            items: itemsToAdd,
            sections: sectionsToRender.join(','),
            sections_url: window.location.pathname
          })
        });

        const parsedState = await response.json();

        if (response.ok) {
          // Dawn fix para evitar errores
          if (!parsedState.id && parsedState.items && parsedState.items.length > 0) {
            parsedState.id = parsedState.items[0].id;
          }

          // Abrimos el carrito drawer nativo
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          // Actualizar icono burbuja si no se auto-actualizó
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
            cartIconBubble.innerHTML = parsedState.sections['cart-icon-bubble'];
          }

          // Resetear selecciones tras éxito dentro de ESTE look
          lookContainer.querySelectorAll('.js-size-select').forEach(s => s.value = "");
          lookContainer.querySelectorAll('.js-clear-size').forEach(b => b.style.display = 'none');
          
          updateLookSubmitBtn(lookContainer);
          this.classList.remove('loading');

        } else {
          console.error('Error:', parsedState);
          this.classList.remove('loading');
          btnText.innerText = 'ERROR, REINTENTA';
          setTimeout(() => updateLookSubmitBtn(lookContainer), 3000);
        }

      } catch (error) {
        console.error('Error de red:', error);
        this.classList.remove('loading');
        btnText.innerText = 'ERROR DE RED';
        setTimeout(() => updateLookSubmitBtn(lookContainer), 3000);
      }
    });
  });

});